/* LINEOUT — capa "vivo": textos, reveal y micro-interacciones. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. "Impuestos incluidos" -> "IVA incluido" (ficha, carro y cajón) */
  function fixTax(root) {
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (/Impuestos incluidos/i.test(n.nodeValue)) {
        n.nodeValue = n.nodeValue.replace(/Impuestos incluidos/gi, 'IVA incluido');
      }
    }
  }

  /* 2. Reveal escalonado de tarjetas Dawn */
  function setupReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var items = document.querySelectorAll('.card-wrapper:not(.v-rv), .collection-list__item:not(.v-rv)');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('v-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el, i) {
      el.classList.add('v-rv');
      el.style.transitionDelay = ((i % 4) * 70) + 'ms';
      io.observe(el);
    });
  }

  /* 3. Tilt 3D suave en tarjetas LINEOUT */
  function setupTilt() {
    if (reduce || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    document.querySelectorAll('.lo-card').forEach(function (c) {
      c.addEventListener('mousemove', function (ev) {
        var r = c.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        c.style.setProperty('--tx', (x * 8).toFixed(2) + 'deg');
        c.style.setProperty('--ty', (-y * 8).toFixed(2) + 'deg');
        c.classList.add('v-tilt');
      });
      c.addEventListener('mouseleave', function () {
        c.classList.remove('v-tilt');
        c.style.removeProperty('--tx'); c.style.removeProperty('--ty');
      });
    });
  }

  /* 4. Ripple en botones */
  function setupRipple() {
    if (reduce) return;
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest('.lo-btn, .product-form__submit');
      if (!b) return;
      var r = b.getBoundingClientRect();
      var s = document.createElement('span');
      var d = Math.max(r.width, r.height);
      s.style.cssText = 'position:absolute;border-radius:50%;pointer-events:none;background:rgba(255,255,255,.45);' +
        'width:' + d + 'px;height:' + d + 'px;left:' + (ev.clientX - r.left - d / 2) + 'px;top:' + (ev.clientY - r.top - d / 2) + 'px;' +
        'transform:scale(0);opacity:1;transition:transform .55s ease-out,opacity .7s ease-out';
      if (getComputedStyle(b).position === 'static') b.style.position = 'relative';
      b.style.overflow = 'hidden';
      b.appendChild(s);
      requestAnimationFrame(function () { s.style.transform = 'scale(2.4)'; s.style.opacity = '0'; });
      setTimeout(function () { s.remove(); }, 750);
    }, true);
  }

  function init() {
    fixTax(document.body);
    setupReveal();
    setupTilt();
    setupRipple();
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) fixTax(n); }); });
        setupReveal();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
